import { Link } from "../../../components/Link";

declare interface FormHeaderProps {
  stepTitle: string;
}

export function FormHeader({stepTitle}: FormHeaderProps): JSX.Element {
  return (
    <>
      <h1 className='mb-2'>{stepTitle}</h1>
      <p className='text-lg mb-3'>In case of any errors, please contact&nbsp;
        <Link to={`mailto:honors-it@honors.usf.edu`} target='_blank'>
          honors-it@honors.usf.edu
        </Link>. Do not reach out to other emails.
      </p>
      <p className='text-lg mb-3'>
        Fill out this profile thoughtfully, the data you provide in it will be available to ONS advisors so that
        they can assist you in applying for scholarships and etc. You can edit that data later.
      </p>
      <p className='text-lg mb-3'>
        If you accidentally close the tab or get logged out before you submit the form
        and you use the same browser on the same device, data will be returned back when you open this form again.
      </p>
    </>
  )
}
